import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { ExportIndividualAdditionalDataResponse } from "./type";

export async function exportIndividualsAdditionalData(
  individualId?: string,
): Promise<ExportIndividualAdditionalDataResponse> {
  const params = new URLSearchParams();

  if (individualId) {
    params.append("individualId", individualId);
  }

  let url = apiPaths.individuals.additionalData.export;

  if (params.toString()) {
    url += `?${params}`;
  }

  const response =
    await apiClient.get<ExportIndividualAdditionalDataResponse>(url);

  return response.data;
}
